import { Grid, Typography } from "@mui/material";
import { Field, useForm } from "react-final-form";
import InputRadio from "../../../components/inputRadio/InputRadio";
import FormContainer from "../../../components/FormContainer";
import Libelle from "../../../_i18n/fr.json";
import { IBienFormData } from "./helpers";
import InputField from "../../../components/input/InputField";
import { maskNumTelephone } from "../../../helpers/formatters";
import stylesParcours from "./styleParcours";

export interface ParcoursLocataire {
  nom?: string;
  prenom?: string;
  email?: string;
  telephone?: string;
}
interface Props {
  formValues: IBienFormData;
  isModification: boolean;
  canSeeParcoursLocataire?: boolean;
  dataParcoursLocataire?: ParcoursLocataire;
  statutDossier?: string;
  dossierDuplique?: string;
}
function ChoixParcoursForm({
  formValues,
  isModification,
  canSeeParcoursLocataire,
  dataParcoursLocataire,
  statutDossier,
  dossierDuplique,
}: Props) {
  const { change } = useForm();
  let choixParcours = [{ value: "parcoursADB", label: "Parcours ADB" }];

  const displayCandidatLocataire =
    canSeeParcoursLocataire &&
    (!isModification || (isModification && dataParcoursLocataire));
  //  ON AFFICHE L'iNFO PARCOURS CANDIDAT LOCATAIRE SI :
  // GARANTE LI = AVEC
  // ET ON EST EN CREATION
  // OU ON EST EN MODIFICATION ET LE CHOIX INITIAL EST PARCOURS CL
  if (formValues.garantieLi === "Avec" && displayCandidatLocataire) {
    choixParcours.push({
      value: "parcoursCandidatLocataire",
      label: "Parcours candidat locataire",
    });
  }

  const onGliChange = (value?: "Avec" | "Sans") => {
    if (value === "Sans") {
      change("choixParcours", "parcoursADB");
    }
  };
  return (
    <>
      <h3>{Libelle.pageBien.sections.section4}</h3>
      <FormContainer>
        <Grid item md={5}>
          <Grid container>
            <Grid item xs={12}>
              <Field
                name="garantieLi"
                onChange={onGliChange}
                component={InputRadio}
                items={[
                  { value: "Avec", label: "Avec" },
                  { value: "Sans", label: "Sans" },
                ]}
                label="Garantie Loyers impayés"
                required
                disabled={statutDossier && statutDossier === "VALIDE"}
              />
            </Grid>
          </Grid>
          <Grid container>
            {!dossierDuplique && (
              <Grid item xs={12}>
                <Field
                  name="choixParcours"
                  component={InputRadio}
                  items={choixParcours}
                  label="Choix du parcours"
                  disabled={statutDossier && statutDossier === "VALIDE"}
                  required
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        {displayCandidatLocataire && !dossierDuplique && (
          <Grid item md={6} sx={stylesParcours}>
            <div className="bloc-choixParcours">
              <Typography variant="body2">
                <strong>Parcours ADB</strong> : Parcours complété sur VERTULOO
                par l'administrateur de biens avec dépôt des pièces
              </Typography>
              <br />
              <Typography variant="body2">
                <strong>Parcours candidat locataire</strong> : Parcours complété
                directement par le candidat locataire sur la plateforme QEEPS.
                Lors de la validation de cet écran, un email sera envoyé au
                candidat pour l'inviter à compléter son dossier. Attention, les
                candidats ayant le statut de Rentier, Diplomates ou Personnelle
                d'ambassade ne peuvent pas renseigner leurs dossiers sur la
                plateforme. Dans ce cas, il est nécessaire d'utiliser le
                parcours classique ADB.
              </Typography>
            </div>
          </Grid>
        )}
      </FormContainer>
      {/* PARCOURS LOCATAIRE */}
      {formValues.choixParcours === "parcoursCandidatLocataire" && (
        <>
          <h3>{Libelle.pageBien.sections.section5}</h3>
          <FormContainer>
            {!isModification ? (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} md={3}>
                    <Field
                      name="candidatLocataire.nom"
                      component={InputField}
                      label="Nom"
                      maxLength={50}
                      required
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3}>
                    <Field
                      name="candidatLocataire.prenom"
                      component={InputField}
                      label="Prénom"
                      maxLength={50}
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} md={3}>
                    <Field
                      name="candidatLocataire.email"
                      component={InputField}
                      label="Email"
                      maxLength={50}
                      required
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3}>
                    <Field
                      name="candidatLocataire.telephonePortable"
                      component={InputField}
                      label="N° mobile"
                      mask={maskNumTelephone()}
                      required
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                    <Field
                      name="candidatLocataire.message"
                      component={InputField}
                      label="Message"
                      multiline
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <Grid>
                {" "}
                <Typography variant="body2">
                  Nom : <strong>{dataParcoursLocataire?.nom}</strong>
                </Typography>{" "}
                <Typography variant="body2">
                  Prénom : <strong>{dataParcoursLocataire?.prenom}</strong>
                </Typography>{" "}
                <Typography variant="body2">
                  Email : <strong>{dataParcoursLocataire?.email}</strong>
                </Typography>{" "}
                <Typography variant="body2">
                  Telephone :{" "}
                  <strong>{dataParcoursLocataire?.telephone}</strong>
                </Typography>
              </Grid>
            )}
          </FormContainer>
        </>
      )}
    </>
  );
}

export default ChoixParcoursForm;
